// extracted by mini-css-extract-plugin
export default {"card_body":"Payments_card_body__ZbhvJ","item_wrap":"Payments_item_wrap__zy67Q","balance":"Payments_balance__ys5cS","card_group":"Payments_card_group__VfbRh"};